import { CloseOutlined }       from '@ant-design/icons';
import { CheckOutlined }       from '@ant-design/icons';
import { Tag }                 from 'antd';
import dayjs                   from 'dayjs';
import React                   from 'react';
import { observer }            from 'mobx-react';
import { Button }              from 'antd';
import { Col }                 from 'antd';
import Row                     from 'components/App/Row';
import { EditOutlined }        from '@ant-design/icons';
import { privateLayoutStore }  from 'stores/index';
import rights                  from 'utils/rights';
import AppDownloadBtn          from 'components/App/AppDownloadBtn';
import { getDate }             from 'utils/dateFormatter';
import { getTime }             from 'utils/dateFormatter';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import ShowForm                from 'forms/ShowForm';
import CardBox                 from 'components/App/CardBox';
import Space                   from 'components/App/Space';
import { showDashboardStore }  from 'stores/index';
import ShowModel               from 'models/ShowModel';
import { AppForm }             from 'components/App/AppForm';

import defaultLogoUrl from '/images/default-logo.png?url';

interface ShowDashboardShowInformationsBoxProps {
  synchronize: () => void;
  synchronized: boolean;
}

interface ShowDashboardShowInformationsBoxState {
  show: ShowModel;
}

@observer
class ShowDashboardShowInformationsBox extends React.Component<ShowDashboardShowInformationsBoxProps> {
  public state: ShowDashboardShowInformationsBoxState = {
    show: new ShowModel(),
  };

  public render() {
    const {
      synchronize,
      synchronized,
    } = this.props;


    const {
      showModel,
      source,
    } = showDashboardStore;

    return (
      <div id="show-informations">
        <CardBox
          content={
            <Row>
              <Col lg={8} md={24}>
                <Space size={12}>
                  {showModel.isLoaded && (
                    <img
                      alt="logo"
                      className="logo"
                      src={showModel.logoObjectUrl || defaultLogoUrl}
                    />
                  )}

                  <ul id="documents-list">
                    <li>
                      {showModel.exhibitorGuideObjectUrl ? (
                        <AppDownloadBtn
                          filename={showModel.exhibitorGuideMediaFileName}
                          link={showModel.exhibitorGuideObjectUrl}
                          text={<FormattedMessageWrapper id="Télécharger le règlement" />}
                        />
                      ) : (
                        <FormattedMessageWrapper id="Pas de règlement" />
                      )}
                    </li>
                    <li>
                      {showModel.mapObjectUrl ? (
                        <AppDownloadBtn
                          filename={showModel.mapMediaFileName}
                          link={showModel.mapObjectUrl}
                          text={<FormattedMessageWrapper id="Télécharger les informations !" />}
                        />
                      ) : (
                        <FormattedMessageWrapper id="Pas d'informations salon" />
                      )}
                    </li>
                    {showModel.securityInstructionsOption && (
                      <li>
                        {showModel.securityInstructionsObjectUrl ? (
                          <AppDownloadBtn
                            filename={showModel.securityInstructionsMediaFileName}
                            link={showModel.securityInstructionsObjectUrl}
                            text={<FormattedMessageWrapper id="Télécharger les consignes de sécurité" />}
                          />
                        ) : (
                          <FormattedMessageWrapper id="Pas de notice de sécurité" />
                        )}
                      </li>
                    )}
                  </ul>
                </Space>
              </Col>
              <Col lg={16} md={24} sm={24} span={24} xl={16} xs={24}>
                <Space size={12}>
                  <span className="subtitle">
                    <FormattedMessageWrapper id="Montage" />
                  </span>

                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <small>
                            <FormattedMessageWrapper id="Du" />
                          </small>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {dayjs(showModel.installationDateStart).format('DD/MM/YYYY')}
                          <br />
                          {dayjs(showModel.installationDateStart).format('HH[h]mm')}
                        </td>
                        <td>
                          <small>
                            <FormattedMessageWrapper id="Au" />
                          </small>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {dayjs(showModel.installationDateEnd).format('DD/MM/YYYY')}
                          <br />
                          {dayjs(showModel.installationDateEnd).format('HH[h]mm')}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <span className="subtitle">
                    <FormattedMessageWrapper id="Démontage" />
                  </span>

                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <small>
                            <FormattedMessageWrapper id="Du" />
                          </small>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {dayjs(showModel.uninstallationDateStart).format('DD/MM/YYYY')}
                          <br />
                          {dayjs(showModel.uninstallationDateStart).format('HH[h]mm')}
                        </td>
                        <td>
                          <small>
                            <FormattedMessageWrapper id="Au" />
                          </small>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {dayjs(showModel.uninstallationDateEnd).format('DD/MM/YYYY')}
                          <br />
                          {dayjs(showModel.uninstallationDateEnd).format('HH[h]mm')}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <span className="subtitle">
                    <FormattedMessageWrapper id="Date limite envoi" />
                  </span>

                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <small>
                            <FormattedMessageWrapper id="Le" />
                          </small>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {dayjs(showModel.organizerDeadline).format('DD/MM/YYYY')}
                          <br />
                          {dayjs(showModel.organizerDeadline).format('HH[h]mm')}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          ({showModel.organizerDeadlineDate?.fromNow()})
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <span className="subtitle">
                    <FormattedMessageWrapper id="Synchronisation des stands" />
                  </span>

                  <Row>
                    <Col span={12}>
                      {(showModel.externalSync && showModel.externalSyncAt) && (
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <small>
                                  <FormattedMessageWrapper id="Le" />
                                </small>
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                {getDate(showModel.get('externalSyncAt'))}
                                <br />
                                {getTime(showModel.get('externalSyncAt'))}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}

                      {(showModel.externalSync && !showModel.externalSync) && (
                        <div
                          style={{
                            alignItems: 'center',
                            display: 'flex',
                            height: 47,
                          }}
                        >
                          <FormattedMessageWrapper id="Aucune syncronisation" />
                        </div>
                      )}

                      {!showModel.externalSync && (
                        <span>
                          <FormattedMessageWrapper id="Ce salon n'est pas configuré pour une synchronisation" />
                        </span>
                      )}
                    </Col>

                    <Col span={12}>
                      <Button
                        block
                        disabled={!showModel.externalSync || source.isSso || synchronized}
                        htmlType="button"
                        onClick={() => synchronize()}
                        type="primary"
                      >
                        <FormattedMessageWrapper id="Synchroniser maintenant" />
                      </Button>
                    </Col>
                  </Row>

                  <span className="subtitle">
                    <FormattedMessageWrapper id="Options du salon" />
                  </span>

                  <Row>
                    <Col span={24}>
                      <Space direction="vertical" size={8}>
                        <Tag
                          color={showModel.standAddDecoratorOption ? 'success' : 'error'}
                          icon={showModel.standAddDecoratorOption ? <CheckOutlined /> : <CloseOutlined />}
                        >
                          <FormattedMessageWrapper id="Ajout de décorateur" />
                        </Tag>

                        <Tag
                          color={showModel.securityInstructionsOption ? 'success' : 'error'}
                          icon={showModel.securityInstructionsOption ? <CheckOutlined /> : <CloseOutlined />}
                        >
                          <FormattedMessageWrapper id="Consignes de sécurité" />
                        </Tag>

                        <Tag
                          color={showModel.standDocumentsOption ? 'success' : 'error'}
                          icon={showModel.standDocumentsOption ? <CheckOutlined /> : <CloseOutlined />}
                        >
                          <FormattedMessageWrapper id="Gestion des documents" />
                        </Tag>

                        <Tag
                          color={showModel.mountingAttestationOption ? 'success' : 'error'}
                          icon={showModel.mountingAttestationOption ? <CheckOutlined /> : <CloseOutlined />}
                        >
                          <FormattedMessageWrapper id="Attestation de bon montage" />
                        </Tag>
                      </Space>
                    </Col>
                  </Row>
                </Space>
              </Col>
            </Row>
          }
          extra={
            rights.for.show.edit && (
              <Button
                icon={<EditOutlined />}
                onClick={() => {
                  AppForm.open(ShowForm, {
                    model: showModel,
                    onSuccess: () => {
                      privateLayoutStore.fetchData();
                    },
                  }, {
                    title: <FormattedMessageWrapper id="Modifier un salon" />,
                    width: 1024,
                  });
                }}
              />
            )
          }
          loading={!showModel.isLoaded || showModel.isLoading}
          title={showModel.showName}
        />
      </div>
    );
  }
}

export default ShowDashboardShowInformationsBox;
